import { FormModeConfig, FormModeDefaults } from '../../../base/interfaces/formModes.ts'
import { EntradaInputProp } from '../interfaces'

export type EntradaFormMode = 'rapid' | 'create' | 'edit'

/**
 * Exposicion general de los modos
 */
export const entradaFormModeDefault: FormModeDefaults<EntradaFormMode> = {
  rapid: { disabled: false },
  create: { disabled: false },
  edit: { disabled: false },
}

export const entradaFormModelConfig: FormModeConfig<EntradaInputProp, EntradaFormMode> = {
  numeroEntrada: {
    rapid: { disabled: true },
  },
  fechaDocumento: {
    rapid: { disabled: true },
    create: { disabled: true },
  },
  tipoDocumento: {
    rapid: { disabled: false },
    create: { disabled: true },
  },
  refDocumento: {
    rapid: { disabled: false },
    create: { disabled: true },
  },
  refNroDocumento: {
    rapid: { disabled: false },
    create: { disabled: true },
  },
  metodoPago: {
    rapid: { disabled: false },
    create: { disabled: true },
  },
  moneda: {
    rapid: { disabled: false },
    create: { disabled: true },
  },
  'aux.seleccionArticulo': {
    rapid: { hidden: false },
    create: { hidden: false },
  },
}
